<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="container-clients">
    <h1 class="title">{{'VALIDATE_CLIENT' | translate}}</h1>
    
    <div class="form-card">
      <!-- Búsqueda -->
      <div class="search-container">
        <div class="search-input-wrapper">
          <input 
            type="text" 
            [(ngModel)]="searchString" 
            placeholder="{{'VALIDATE_CLIENT_HELP_TEXT' | translate}}"
            class="form-control"
          >
          <button class="btn primary-btn" (click)="serchClient()">
            {{'SEARCH' | translate}}
          </button>
        </div>
      </div>

      <!-- Mensaje sin resultados -->
      <div *ngIf="dataStatus === 0 && !loading" class="no-results">
        {{'NO_RESULTS' | translate}}
      </div>

      <!-- Información del cliente y artículos -->
      <div *ngIf="dataStatus === 1 && client && !loading" class="client-content">
        <!-- Header del cliente -->
        <div class="client-header">
          <div class="client-info-card">
            <h3 class="client-title">{{ 'CUSTOMER_INFORMATION' | translate }}</h3>
            <div class="info-row">
              <span class="info-label">{{'NAME' | translate}}:</span>
              <span class="info-value">{{ client?.firstName || ''}} {{ client?.lastName || ''}}</span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ 'IDENTIFICATION' | translate }}:</span>
              <span class="info-value">{{ client?.nationalId || '' }}</span>
            </div>
            <div class="info-row" *ngIf="client?.email">
              <span class="info-label">{{'EMAIL' | translate}}:</span>
              <span class="info-value">{{ client?.email }}</span>
            </div>
            <div class="info-row" *ngIf="client?.phone">
              <span class="info-label">{{'PHONE' | translate}}:</span>
              <span class="info-value">{{ client?.phone }}</span>
            </div>
          </div>
        </div>

        <!-- Órdenes de compra agrupadas -->
        <div class="orders-container">
          
          <!-- Mensaje si no hay órdenes -->
          <div *ngIf="paginatedOrders.length === 0" class="no-orders">
            <i class="fas fa-inbox"></i>
            <p>No hay órdenes de compra registradas</p>
          </div>
          
          <!-- Cards de órdenes paginadas -->
          <div *ngFor="let order of paginatedOrders" class="order-card">
            <div class="order-header">
              <div class="order-info">
                <span class="order-id">Orden #{{ order.saleId }}</span>
                <span class="order-date" *ngIf="order.saleDate">
                  {{ order.saleDate | date:'dd/MM/yyyy' }} 
                  <span class="time-elapsed">({{ getTimeElapsed(order.saleDate) }})</span>
                </span>
              </div>
              <div class="order-summary">
                <span class="items-count">{{ order.items.length }} {{ order.items.length === 1 ? 'artículo' : 'artículos' }}</span>
              </div>
            </div>

            <!-- Items de la orden -->
            <div class="order-items">
              <div *ngFor="let item of order.items; let last = last" class="item-card">
                <div class="package-main-info">
                  <div class="package-image-wrapper">
                    <img [src]="item.imageURL || '/assets/static/missing-image.png'" 
                        [alt]="item.productName" 
                        class="package-image">
                  </div>
                  
                  <div class="package-details">
                    <div class="package-name">
                      {{ item.productName }}
                    </div>
                    
                    <div class="package-grid">
                      <div class="package-field">
                        <span class="field-label">{{ 'CODE' | translate }}:</span>
                        <span class="field-value">{{ item.itemCode }}</span>
                      </div>
                      
                      <!-- Select de beneficiarios (solo para productos que los tengan) -->
                      <!-- Dentro del ng-container de hijos, agregar esto en item-grid: -->
                      <div class="item-field" *ngIf="item.beneficiaries?.length > 0">
                        <span class="field-label">{{ 'BENEFICIARIES' | translate }}:</span>
                        <select class="form-select form-select-sm"
                                [(ngModel)]="selectedBeneficiary[getItemId(item)]"
                                (ngModelChange)="onBeneficiaryChange(order.saleId, item, $event)">
                          <option *ngFor="let beneficiary of item.beneficiaries" [ngValue]="beneficiary.beneficiaryId">
                            {{ beneficiary.beneficiaryName || 'Sin nombre' }} - 
                            {{ beneficiary.beneficiaryRelationship || '' }}
                          </option>
                        </select>
                      </div>
                      
                      <!-- Sesiones disponibles (solo tipo 2) -->
                      <div class="package-field" *ngIf="[2].includes(item.productType)">
                        <span class="field-label">{{ 'SESSIONS_AVAILABLE' | translate }}:</span>
                        <span class="field-value">
                          {{ getAvailableSessions(order.saleId, item) }} / {{ item.itemSessions }}
                        </span>
                      </div>
                      
                      <div class="package-field">
                        <span class="field-label">{{ 'QUANTITY' | translate }}:</span>
                        <span class="field-value">{{ item.saleItemQuantity }}</span>
                      </div>
                      
                      <div class="package-field" *ngIf="item.saleItemUnitCost > 0">
                        <span class="field-label">{{ 'PRICE' | translate }}:</span>
                        <span class="field-value price">{{ appComponent.formatMoney(item.saleItemUnitCost) }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="package-actions">
                    <!-- Botón descontar (solo tipo 2) -->
                    <button 
                      class="btn-discount" 
                      (click)="discountSesion(item)"
                      [disabled]="getAvailableSessions(order.saleId, item) <= 0 || itemLoading[getItemId(item)]"
                      *ngIf="[2].includes(item.productType)">
                      
                      <!-- Contenido normal del botón -->
                      <span *ngIf="!itemLoading[getItemId(item)]" class="btn-text">
                        Descontar 1 sesión
                      </span>
                      
                      <!-- Contenido de loading -->
                      <span *ngIf="itemLoading[getItemId(item)]" class="btn-loading">
                        <span class="spinner-mini"></span>
                        <span>Procesando...</span>
                      </span>
                    </button>

                    <!-- Mensaje de éxito/error -->
                    <div *ngIf="itemMessages[getItemId(item)]" 
                        class="package-message"
                        [class.success]="itemMessages[getItemId(item)]?.type === 'success'"
                        [class.error]="itemMessages[getItemId(item)]?.type === 'error'">
                      <i class="fas" 
                        *ngIf="itemMessages[getItemId(item)]?.type === 'success'"
                        style="margin-right: 5px;">✓</i>
                      <i class="fas" 
                        *ngIf="itemMessages[getItemId(item)]?.type === 'error'"
                        style="margin-right: 5px;">✕</i>
                      <span>{{ itemMessages[getItemId(item)]?.message }}</span>
                    </div>
                  </div>
                </div>
                
                <!-- Hijos del paquete -->
                <ng-container *ngIf="item.children?.length" class="child-items">
                  <ng-container *ngFor="let child of item.children">
                    <div class="item-main-info mb-3">
                      <div class="item-image-wrapper">
                        <img [src]="child.imageURL || '/assets/static/missing-image.png'" 
                            [alt]="child.productName" 
                            class="item-image">
                      </div>
                      
                      <div class="item-details">
                        <div class="item-name">
                          {{ child.productName }}
                        </div>
                        
                        <div class="item-grid">
                          <div class="item-field">
                            <span class="field-label">{{ 'CODE' | translate }}:</span>
                            <span class="field-value">{{ child.itemCode }}</span>
                          </div>
                          
                          <!-- Sesiones disponibles hijo (solo tipo 2) -->
                          <div class="item-field" *ngIf="[2].includes(child.productType)">
                            <span class="field-label">{{ 'SESSIONS_AVAILABLE' | translate }}:</span>
                            <span class="field-value">
                              {{ getAvailableSessions(order.saleId, child) }} / {{ child.itemSessions }}
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      <div class="item-actions">
                        <!-- Botón descontar hijo (solo tipo 2) -->
                        <button 
                          class="btn-discount" 
                          (click)="discountSesion(child)"
                          [disabled]="getAvailableSessions(order.saleId, child) <= 0 || itemLoading[getItemId(child)]"
                          *ngIf="[2].includes(child.productType)">
                          
                          <!-- Contenido normal del botón -->
                          <span *ngIf="!itemLoading[getItemId(child)]" class="btn-text">
                            Descontar 1 sesión
                          </span>
                          
                          <!-- Contenido de loading -->
                          <span *ngIf="itemLoading[getItemId(child)]" class="btn-loading">
                            <span class="spinner-mini"></span>
                            <span>Procesando...</span>
                          </span>
                        </button>

                        <!-- Mensaje de éxito/error hijo -->
                        <div *ngIf="itemMessages[getItemId(child)]" 
                            class="item-message"
                            [class.success]="itemMessages[getItemId(child)]?.type === 'success'"
                            [class.error]="itemMessages[getItemId(child)]?.type === 'error'">
                          <i class="fas" 
                            *ngIf="itemMessages[getItemId(child)]?.type === 'success'"
                            style="margin-right: 5px;">✓</i>
                          <i class="fas" 
                            *ngIf="itemMessages[getItemId(child)]?.type === 'error'"
                            style="margin-right: 5px;">✕</i>
                          <span>{{ itemMessages[getItemId(child)]?.message }}</span>
                        </div>
                      </div>
                    </div>
                  </ng-container> 
                </ng-container>

                <!-- Tabs colapsables -->
                <div class="item-tabs" *ngIf="hasValidSections(item)">
                  
                  <!-- Tab Condiciones -->
                  <div class="tab-header" 
                      *ngIf="hasValidConditions(item.productConditions)"
                      (click)="toggleTab(getItemId(item), 'conditions')">
                    <span class="tab-title">{{'CONDITIONS' | translate}}</span>
                    <span class="tab-icon" [class.expanded]="isTabExpanded(getItemId(item), 'conditions')">
                      <span class="arrow-down"></span>
                    </span>
                  </div>
                  
                  <div class="tab-content" 
                      *ngIf="hasValidConditions(item.productConditions) && isTabExpanded(getItemId(item), 'conditions')">
                    <div class="tab-body">
                      <div [innerHTML]="item.productConditions"></div>
                    </div>
                  </div>

                  <!-- Tab Beneficiarios -->
                  <div class="tab-header" 
                      *ngIf="hasValidBeneficiaries(item.beneficiaries)"
                      (click)="toggleTab(getItemId(item), 'beneficiaries')">
                    <span class="tab-title">{{'BENEFICIARIES' | translate}}</span>
                    <span class="tab-icon" [class.expanded]="isTabExpanded(getItemId(item), 'beneficiaries')">
                      <span class="arrow-down"></span>
                    </span>
                  </div>
                  
                  <div class="tab-content" 
                      *ngIf="hasValidBeneficiaries(item.beneficiaries) && isTabExpanded(getItemId(item), 'beneficiaries')">
                    <div class="tab-body beneficiaries-list">
                      <div *ngFor="let beneficiary of item.beneficiaries" class="beneficiary-item">
                        <div class="beneficiary-info">
                          <span class="beneficiary-name">{{ beneficiary.beneficiaryName || beneficiary.name || 'Sin nombre' }}</span>
                          <span class="beneficiary-relationship">{{ beneficiary.beneficiaryRelationship || beneficiary.relationship || '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!last" class="item-divider"></div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Controles de Paginación -->
        <div *ngIf="totalPages > 1" class="pagination-container">
          <div class="pagination-info">
            Mostrando {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, groupedOrders.length) }} de {{ groupedOrders.length }} órdenes
          </div>
          
          <div class="pagination-controls">
            <!-- Botón Anterior -->
            <button 
              class="pagination-btn" 
              (click)="previousPage()" 
              [disabled]="currentPage === 1">
              <span class="arrow-left">←</span>
              <span>Anterior</span>
            </button>
            
            <!-- Números de página -->
            <div class="page-numbers">
              <button 
                *ngFor="let page of getPagesArray()" 
                class="page-number" 
                [class.active]="currentPage === page"
                (click)="changePage(page)">
                {{ page }}
              </button>
            </div>
            
            <!-- Botón Siguiente -->
            <button 
              class="pagination-btn" 
              (click)="nextPage()" 
              [disabled]="currentPage === totalPages">
              <span>Siguiente</span>
              <span class="arrow-right">→</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="loading" class="loading">
        <div class="spinner-border" role="status"></div>
        <span class="sr-only">{{'LOADING' | translate}}...</span>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>